// file: src/services/mcpServices.js

import request from './requestServices';

// API routes for MCP operations
const API_MCP_STATUS_URL = '/v1/mcp/status';
const API_MCP_BLENDER_EXECUTE_URL = '/v1/mcp/blender/execute';

/**
 * Get the status of available MCP agents
 * @returns {Promise<Object>} Status of all MCP agents
 */
export async function getMCPStatus() {
  try {
    const { data } = await request(API_MCP_STATUS_URL, {
      method: 'GET',
    });
    return data.data;
  } catch (error) {
    console.error('Error getting MCP status:', error);
    throw error;
  }
}

/**
 * Execute a Blender MCP command
 * @param {string} command - The command to execute
 * @param {Object} params - Parameters for the command
 * @param {string} serverName - The Blender server name (default: 'default')
 * @returns {Promise<Object>} Result of the command execution
 */
export async function executeBlenderMCP(command, params = {}, serverName = 'default') {
  try {
    const { data } = await request(API_MCP_BLENDER_EXECUTE_URL, {
      method: 'POST',
      data: {
        command,
        params,
        server_name: serverName,
      },
    });
    return data.data;
  } catch (error) {
    console.error('Error executing Blender MCP command:', error);
    throw error;
  }
}

/**
 * Available agent types
 */
export const AGENT_TYPES = {
  ASK: 'ask',
  BLENDER: 'blender',
  FREECAD: 'freecad',
  JUPYTERLAB: 'jupyterlab',
  KICAD: 'kicad',
};

/**
 * Agent type labels for display
 */
export const AGENT_LABELS = {
  [AGENT_TYPES.ASK]: 'Ask',
  [AGENT_TYPES.BLENDER]: 'Blender Agent',
  [AGENT_TYPES.FREECAD]: 'FreeCAD Agent',
  [AGENT_TYPES.JUPYTERLAB]: 'JupyterLab Agent',
  [AGENT_TYPES.KICAD]: 'KiCAD Agent',
};

/**
 * Agent type descriptions
 */
export const AGENT_DESCRIPTIONS = {
  [AGENT_TYPES.ASK]: 'Ask questions using knowledge bases',
  [AGENT_TYPES.BLENDER]: '3D modeling and scene manipulation',
  [AGENT_TYPES.FREECAD]: 'CAD modeling and design',
  [AGENT_TYPES.JUPYTERLAB]: 'Data analysis and visualization',
  [AGENT_TYPES.KICAD]: 'PCB design and electronics',
}; 